import PropTypes from 'prop-types';
import { ICON_PROP_TYPES } from '../icon/types';

export const OPTION_TYPE = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.shape(ICON_PROP_TYPES),
  note: PropTypes.string,
  formatLabel: PropTypes.func,
};

export const GROUP_OPTION_TYPE = {
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape(OPTION_TYPE)).isRequired,
};
